/**
 * Audio Configuration & Feature Flag
 * 
 * Set AUDIO_ENABLED to true to re-enable background music and the
 * "Sound On" / "Sound Off" toggle buttons across the desktop navbar and mobile drawer.
 * Set to false to deactivate audio playback, gesture listeners, and hide the sound buttons.
 */
export const AUDIO_ENABLED = false;
